module.exports = __webpack_public_path__ + "img/ad-bg-motp-1@3x.ebe05794.png";